import { useEffect, useMemo } from "react";
import { useStripe, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import Loader from "components/common/controls/Loader";

loadStripe.setLoadParameters({ advancedFraudSignals: false });
const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

interface Props {
  sessionId: string;
}

export default function StripeCheckoutRedirection(props: Props) {
  const stripePromise = useMemo(() => {
    return loadStripe(stripePublishableKey);
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <CheckoutRedirection sessionId={props.sessionId} />
    </Elements>
  );
}

const CheckoutRedirection = (props: Props) => {
  const stripe = useStripe();
  useEffect(() => {
    if (stripe) {
      stripe.redirectToCheckout({
        sessionId: props.sessionId,
      });
    }
  }, [stripe, props.sessionId]);
  return <Loader isVisible={true} />;
};
